import { http } from '@/plugins/http';
import { getData } from '@/utils/get';

class ZerotierNetwork {
  get = () => http.post('zerotier-networks', []).then(getData);
}

export default new ZerotierNetwork();
